export const spacer = {
  defaultMobileHeight: '2rem',
  defaultDekstopHeight: '3.75rem',
  remConverter: 16,
  unit: 'rem',
};
